import React from 'react';

import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from '@mui/material/Typography';

const Footer = () =>{
    const dt = new Date();
    const year = dt.getFullYear();
    const version = process.env.REACT_APP_VERSION || '1.0.1';
    const text = `Ad'oro © ${year} - Versão ${version}`;
    
    return(
       
            <Box 
                sx={{ display: 'flex', 
                      justifyContent: 'center', 
                      alignItems: 'center', 
                      bgcolor: 'background.paper', 
                      color: 'primary.text',
                      minHeight: 30,
                      bottom: 0, 
                      width: '100%'
                    }} 
                      position='fixed'
            >
                <Container maxWidth='lg'>
                    <Grid>
                        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <Typography
                                sx={{
                                    fontSize: 14
                                }}
                            >
                                {text}
                            </Typography>
                        </Box>
                    </Grid>
                </Container>
            </Box>
       
    );
};

export default Footer;